import slice from '../slice';

export default function dropLastWhile(pred, xs) {
  var idx = xs.length - 1;
  while (idx >= 0 && pred(xs[idx])) {
    idx -= 1;
  }
  return slice(0, idx + 1, xs);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_dropLastWhile.js
// module id = ../node_modules/ramda/es/internal/_dropLastWhile.js
// module chunks = 5